import { variableSearch } from '../../../const';
import { Design, VariableScope } from '../../../types';
import { getPromptText, GetPromptTextProps } from './get-prompt-text';

export type VariableInfo = {
  fullName: string;
  scope: VariableScope;
  variableName: string;
};

export type GetVariablesFromTextProps = (
  Omit<GetPromptTextProps, 'variableParsing'>
  & {
    serialized: Design;
  }
);

export function getVariablesFromText({
  serialized,
  ...props
}: GetVariablesFromTextProps): VariableInfo[] {
  const { omniChannel: { isOmniChannel } } = serialized;
  const variables: VariableInfo[] = [];
  const text = getPromptText({
    ...props,
    channel: (isOmniChannel) ? props.channel : null,
    // Set to undefined in case they pass this as an extra property.
    variableParsing: undefined
  });

  while (true) {
    let match = variableSearch.exec(text ?? '');
    if (!match) {
      break;
    }
    const [_, fullName, scope, variableName] = match;
    variables.push({
      fullName,
      scope: scope as VariableScope,
      variableName
    });
  }

  return variables;
}
